/**
 * Inserts a newly created drip item into the list (mutates array)
 * Only inserts if the same contentPostId does not already exist.
 */
export function insertDripItem(currentDripItem, newItem) {
  if (!newItem?.contentPostId) return false;

  const exists = currentDripItem.some(
    i => Number(i.contentPostId) === Number(newItem.contentPostId)
  );

  if (exists) return false;

  currentDripItem.push(newItem);
  return true;
}
